import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { select } from '@ngneat/elf';
import { DacGeneralParamsStateProps, dacGeneralParamsStateStore, dacGeneralParamsInitialState } from './dac-general-params-state.store';

@Injectable({
  providedIn: 'root',
})
export class DacGeneralParamsRepository extends BaseStoreRepository<DacGeneralParamsStateProps> {
  constructor() {
    super(dacGeneralParamsStateStore.pipe(select(state => state)), dacGeneralParamsStateStore, dacGeneralParamsInitialState);
  }
}
